import { TextField } from '@blueprinthq/joy'
import {
  Button,
  Image,
  ModalBody,
  ModalContent,
  Text,
  VStack
} from '@chakra-ui/react'
import { YupPhone } from '@constants/formValidation'
import { Field, Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { useCalendarEvent } from '../../context/calendar-event.context'
import { EventModalFooter } from './event-modal-footer'
import { EventModalHeader } from './event-modal-header'

interface MissingClientInfoModalProps {
  onCancel: () => void
  onSendManually: () => void
  onSubmit: (patient_id: string, email: string, phoneNumber: string) => void
}

export interface UpdateClientFormValues {
  email: string
  phoneNumber: string | null
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  phoneNumber: YupPhone
})

export const MissingClientInfoModal: React.FC<MissingClientInfoModalProps> = ({
  onCancel,
  onSendManually,
  onSubmit
}) => {
  const { currentEvent } = useCalendarEvent()

  // Use the appropriate event based on whether we're editing or creating
  const eventData = currentEvent

  if (!eventData) {
    return null // Don't render if no event data
  }

  const initialValues = {
    email: currentEvent?.patient?.email || '',
    phoneNumber: currentEvent?.patient?.phoneNumber || ''
  }

  const handleSubmit = async (values: UpdateClientFormValues) => {
    if (!currentEvent?.patient?.id) {
      return
    }
    onSubmit(currentEvent?.patient?.id, values.email, values.phoneNumber || '')
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, isValid, dirty, isSubmitting, setFieldValue }) => (
        <Form style={{ width: '100%' }}>
          <ModalContent>
            <EventModalHeader showCloseButton={true} onClose={onCancel}>
              <Text>Add email</Text>
            </EventModalHeader>
            <ModalBody>
              <VStack mb="xsmall" spacing="small" w="100%">
                <Image
                  src="https://res.cloudinary.com/hellojoy/image/upload/v1749147107/images/add_email.png"
                  alt="Add email"
                  w="211px"
                  h="111px"
                />
                <Text alignSelf="flex-start">
                  We noticed there is no email on file. Please add an email
                  address so we can notify {currentEvent?.patient?.firstName}{' '}
                  about their appointment.
                </Text>
                <Field name="email">
                  {({ field }: { field: any }) => (
                    <TextField
                      {...field}
                      label="Email"
                      isInvalid={errors.email && touched.email}
                      isRequired
                      width="100%"
                      bg="white"
                    />
                  )}
                </Field>
                {/* TODO: Add phone number field */}
              </VStack>
            </ModalBody>
            <EventModalFooter gap="10px">
              <Button
                onClick={async () => {
                  onSendManually()
                }}
                isFullWidth
                borderRadius="8px"
                variant="outline"
                m="0px"
              >
                I'll send manually
              </Button>
              <Button type="submit" isFullWidth borderRadius="8px" m="0px">
                Continue
              </Button>
            </EventModalFooter>
          </ModalContent>
        </Form>
      )}
    </Formik>
  )
}
